<!--

	Displays information about founders and team members 

-->
<template>
	<div class="mia-SiteAbout">
		<h3 v-tr="'MeetTheFounders'" />
		<div v-tr="'MeetTheFoundersText'" class="mia-foundersText" />
		<responsive-image :from="foundersPicture" class="mia-u-fillParentWidth" />
		<team-member-list title="MeetTheFoundersTitle" :members="founders" />
		<div v-tr="'siteabout_description'" class="mia-description" />
		<team-member-list title="meettheteamtitle" :members="teamMembers" />
	</div>
</template>
<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import TeamMemberList from "./lists/TeamMemberList.vue";
import Founders from "@theme/founders.jpg";
import { MiaPlaza } from "@/Reinforced.Typings";
import ResponsiveImage from "@/Control/Vue/ResponsiveImage";

@Component({
	components: {
		TeamMemberList, 
		ResponsiveImage
	},
})
export class SiteAbout extends Vue {
	@Prop({required: true, type: Array}) founders!: MiaPlaza.Control.Vue.ITeamMember[];
	@Prop({required: true, type: Array}) teamMembers!: MiaPlaza.Control.Vue.ITeamMember[];

	readonly foundersPicture = Founders;
}

export default toNative(SiteAbout);
</script>
<style lang="scss">
.mia-SiteAbout {
	.mia-foundersText {
		padding-bottom: theme.$mia-padding-panel;
	}
}
@media(max-width: theme.$screen-xs-max) {
	.mia-SiteAbout {
		padding: 0 theme.$mia-padding-panel;
	}
}
</style>
